/**
 * Props for the SignInCard component.
 */
interface SignInCardProps {
  /** Plain-text prefix, e.g. "Already have an account?" */
  text: string;
  /** Link label, e.g. "Sign in instead ›" */
  linkLabel: string;
  /** Click handler that triggers the sign-in flow. */
  onSignIn: () => void;
}

/**
 * Prominent white card offering the existing-account sign-in path.
 * Sits below the dark CTA card so users with accounts have a clear way out.
 */
export function SignInCard({ text, linkLabel, onSignIn }: SignInCardProps) {
  return (
    <section
      className="bg-white rounded-[14px] px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 text-center"
      style={{
        border: '0.5px solid rgba(36,36,36,0.12)',
      }}
    >
      <span
        className="text-[17px] font-medium text-[#242424]"
        style={{ fontFamily: '"Urbanist", "Helvetica", sans-serif' }}
      >
        {text}
      </span>
      <button
        type="button"
        onClick={onSignIn}
        className="text-[17px] font-bold text-[#ff7e1a] cursor-pointer hover:opacity-80 transition-opacity"
        style={{
          fontFamily: '"Urbanist", "Helvetica", sans-serif',
          textDecoration: 'underline',
          textUnderlineOffset: '4px',
        }}
      >
        {linkLabel}
      </button>
    </section>
  );
}
